import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["message", "submit", "sendVia"];

  connect() {
    $("#groups-to-notify").dropdown({ fullTextSearch: true });
  }

  setContent() {
    const content = this.data.get("content");
    if (content && content.length) {
      this.messageTarget.value = content;
    }
    this.validate();
  }

  validate() {
    let selectedSendVia = true;
    const placeholderRegex = /\[\[.*\]\]/;
    const textareaValues = this.messageTargets.map((textarea) => textarea.value);
    if (this.hasSendViaTarget) {
      const list = $(this.sendViaTarget);
      const listItems = list.find("input:checked");
      selectedSendVia = listItems.length > 0;
    }
    const messageLengths = textareaValues
      .map((string) => string.trim())
      .map((string) => string.length);
    const hasNoMessage = messageLengths.includes(0);
    const messagePlaceholders = textareaValues.map((string) => placeholderRegex.test(string));
    const hasPlaceholders = messagePlaceholders.includes(true);
    const isUploading = this.element.querySelector('[data-uploading="true"]');
    if (isUploading || !selectedSendVia || hasNoMessage || hasPlaceholders) {
      this.disableSubmit();
    } else {
      this.enableSubmit();
    }
  }

  disableSubmit() {
    this.submitTarget.classList.add("disabled");
  }

  enableSubmit() {
    this.submitTarget.classList.remove("disabled");
  }
}
